module.exports = __webpack_public_path__ + "img/pin-third.32cffb32.svg";